import React, { useState } from "react";
import { get } from "lodash";
import T from "prop-types";
import { Col } from "react-bootstrap";
import { FormRow } from "MODULES/shared/components/Forms";
import { API_BASE } from "APP_ROOT/constants";

export function Form({ close, lineItem, purchaseOrderId }) {
  const [sellersContractNumber, setSellersContractNumber] = useState(
    get(lineItem, "inventories[0].purchase_order_line_item.invoice_number") ||
      get(lineItem, "inventory.purchase_order_line_item.invoice_number")
  );
  const [obtainedFrom, setObtainedFrom] = useState(lineItem.company_name);
  const [referenceNumber, setReferenceNumber] = useState(null);
  const [certPreparedFor, setCertPreparedFor] = useState(null);

  let url;

  if (lineItem.record_type === "ReceivingRecord") {
    url =
      `${API_BASE}/sales_order_line_items/${lineItem.reference_record_line_item_id}` +
      `/download_certificate_of_conformance?received_core=true&obtained_from_type=other&obtained_from_text=${obtainedFrom ||
        ""}&sellers_contract_number=${sellersContractNumber || ""}`;
  } else {
    url =
      `${API_BASE}/purchase_orders/${purchaseOrderId}/received_cores/${lineItem.id}` +
      `/download_certificate_of_conformance?received_core=true&obtained_from_type=other&obtained_from_text=${obtainedFrom ||
        ""}&sellers_contract_number=${sellersContractNumber ||
        ""}&cert_prepared_for=${certPreparedFor ||
        ""}&reference_number=${referenceNumber}`;
  }

  return (
    <React.Fragment>
      <FormRow>
        <Col md={6}>
          <div className="form-group">
            <label className="control-label" htmlFor="obtained_from">
              Obtained From
            </label>
            <input
              type="text"
              name="obtained_from"
              className="form-control"
              value={obtainedFrom}
              onChange={e => setObtainedFrom(e.target.value)}
            />
          </div>
        </Col>
        <Col md={6}>
          <div className="form-group">
            <label className="control-label" htmlFor="sellers_contract_number">
              Seller&apos;s Contract #:
            </label>
            <input
              type="text"
              name="sellers_contract_number"
              className="form-control"
              value={sellersContractNumber}
              onChange={e => setSellersContractNumber(e.target.value)}
            />
          </div>
        </Col>
      </FormRow>
      {lineItem.record_type !== "ReceivingRecord" && (
        <FormRow>
          <Col md={6}>
            <div className="form-group">
              <label className="control-label" htmlFor="reference_number">
                Reference #
              </label>
              <input
                type="text"
                name="reference_number"
                className="form-control"
                value={referenceNumber}
                onChange={e => setReferenceNumber(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="form-group">
              <label className="control-label" htmlFor="cert_prepared_for">
                Cert Prepared For
              </label>
              <input
                type="text"
                name="cert_prepared_for"
                className="form-control"
                value={certPreparedFor}
                onChange={e => setCertPreparedFor(e.target.value)}
              />
            </div>
          </Col>
        </FormRow>
      )}
      <div className="clearfix">
        <button
          className="pull-right btn btn-primary"
          onClick={() => {
            window.open(url, "_blank");
            close();
          }}
        >
          <span>&nbsp;Download CoC </span>
        </button>
      </div>
    </React.Fragment>
  );
}

Form.propTypes = {
  close: T.func.isRequired,
  lineItem: T.shape({})
};

export default Form;



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/DownloadCocModal/Form.jsx